var map = {
  "./divider--footer.svg": "8888",
  "./divider.svg": "9731",
  "./icon-account.svg": "9873",
  "./icon-arrow.svg": "3815",
  "./icon-chevron.svg": "2981",
  "./icon-clock.svg": "662",
  "./icon-close.svg": "7408",
  "./icon-depot.svg": "3258",
  "./icon-email.svg": "692",
  "./icon-facebook.svg": "704",
  "./icon-fish.svg": "3834",
  "./icon-info.svg": "1552",
  "./icon-instagram.svg": "4936",
  "./icon-knife.svg": "7655",
  "./icon-linkedin.svg": "2690",
  "./icon-mail.svg": "4913",
  "./icon-menu.svg": "9617",
  "./icon-minus.svg": "7924",
  "./icon-office.svg": "8124",
  "./icon-oven.svg": "62",
  "./icon-pagination-active.svg": "4119",
  "./icon-pagination-inactive.svg": "7238",
  "./icon-person.svg": "7923",
  "./icon-phone.svg": "4920",
  "./icon-plus.svg": "172",
  "./icon-recipe-ticked.svg": "2591",
  "./icon-recipe-unticked.svg": "5674",
  "./icon-seafood.svg": "6497",
  "./icon-search.svg": "7632",
  "./icon-shop.svg": "7488",
  "./icon-speechmark.svg": "4889",
  "./icon-star.svg": "5540",
  "./icon-tick-withbox.svg": "8335",
  "./icon-tick.svg": "2139",
  "./icon-tickbox.svg": "2458"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4123;
